import { useAuthStore } from '@/stores/auth-store';
import { signInWithApple, signInWithGoogle } from './use-auth';

/**
 * Shared sign-in surface for the post-purchase Register step.
 * The funnel decides what to do once authenticated.
 */
export function useSignIn() {
  const status = useAuthStore((s) => s.status);
  const user = useAuthStore((s) => s.user);

  const handleApple = async () => {
    try {
      await signInWithApple();
    } catch (err) {
      console.error('Apple sign-in failed:', err);
    }
  };

  const handleGoogle = async () => {
    try {
      await signInWithGoogle();
    } catch (err) {
      console.error('Sign-in failed:', err);
    }
  };

  return { status, user, handleApple, handleGoogle };
}
